import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers, images } from "../data/content";
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5000;
const INTERVAL_MS = 14000;
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [minutes, setMinutes] = useState(2);
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const reveal = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutes(Math.floor(Math.random() * 14) + 1);
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), VISIBLE_MS);
    };
    const first = window.setTimeout(reveal, FIRST_DELAY);
    const loop = window.setInterval(reveal, INTERVAL_MS);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-262" data-mp="24rh9vy9efkvv">
      {show && !dismissed && <motion.div role="status" className="fixed left-3 right-3 top-3 z-50 sm:bottom-5 sm:left-5 sm:right-auto sm:top-auto sm:w-[340px]" initial={{
      opacity: 0,
      y: -12,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -12,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-263" data-mp="29q2bo24aucmf">
          <div className="flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-wine-100" data-id="element-264" data-mp="2sga7dz5o60sl">
            <img src={images.product} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-265" data-mp="2xfwleatbnl2g" />
            <div className="min-w-0 text-sm leading-snug" data-id="element-266" data-mp="y30t7u26hr40">
              <p className="font-bold text-ink" data-id="element-267" data-mp="131c6keromjqz">
                {buyer.name} <span className="font-normal text-ink-soft" data-id="element-268" data-mp="131vo3udf764h">from</span> {buyer.country}
              </p>
              <p className="text-ink-soft" data-id="element-269" data-mp="v163jjp6wc82">just purchased the digital book <strong className="text-wine-700" data-id="element-270" data-mp="q2crzwtgqvaj">Biomechanics War Room™</strong></p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta-dark" data-id="element-271" data-mp="14ykcky8s9yqc">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-272" data-mp="1000nwq2t28ua" /> Verified · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink-soft hover:bg-cream" aria-label="Dismiss notification" data-id="element-273" data-mp="1dy7cfflv6wha">
              <XIcon className="h-4 w-4" data-id="element-274" data-mp="1iqidilsccobf" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}